<template>
    <section class="content-section container px-3">
        <h2 class="content-section-title">{{title}}</h2>
        <b-row class="justify-content-start">
            <div v-for="(info, index) in infos" :key="index" class="an-wrap">
                <An :info="info" :desc=true />
            </div>
        </b-row>
    </section>
</template>

<script>
import An from '@/components/AnimateSmallBanner'
export default {
    components: { An },
    data() {
        return {
            title: 'LAB EQUIPMENTS',
            infos: [
                {'title': 'Rheometer', 'desc': 'Analysis of rubber vulcanization characteristics.' , 'img': require('@/assets/images/lab/eq/rheometer.jpg')},
                {'title': 'Ozone Aging Test Chamber', 'desc': 'Ozone resistance evaluation (72 hours)' , 'img': require('@/assets/images/lab/eq/ozone_test.jpg')},
                {'title': 'Universal Testing Machine (Rubber)', 'desc': 'Tensile, tear, and compression testing for rubber.' , 'img': require('@/assets/images/lab/eq/tensile_test.jpg')},
                {'title': 'Thermal Aging Test Chamber', 'desc': 'High-temperature aging performance evaluation.' , 'img': require('@/assets/images/lab/eq/aging_test.jpg')},
                {'title': 'High & Low Temperature Cycling Chamber', 'desc': 'Thermal cycling test from -30°C to 70°C.' , 'img': require('@/assets/images/lab/eq/high-low_temp.jpg')},
                {'title': 'Salt Spray Test Chamber', 'desc': 'Corrosion resistance testing.' , 'img': require('@/assets/images/lab/eq/salt_spray_tester.jpg')},
                {'title': 'UV Weathering Test Chamber', 'desc': 'UV resistance testing (400 hours)' , 'img': require('@/assets/images/lab/eq/uv_resistance_tester.jpg')},
                {'title': 'Drop Impact Tester', 'desc': 'High-impact resistance testing for components.' , 'img': require('@/assets/images/lab/eq/flick_test.jpg')},
                {'title': 'Snow Test', 'desc': 'Test the wiper\'s wiping performance in a snowy climate.' , 'img': require('@/assets/images/lab/eq/snow_test.jpg')},
                {'title': 'Noise Test', 'desc': 'Wiping noise level measurement (<70 dB)' , 'img': require('@/assets/images/lab/eq/noise_test.jpg')},
                {'title': 'High Speed Test', 'desc': 'Test the wiper\'s wiping performance at high speed (180km / h).' , 'img': require('@/assets/images/lab/eq/high-speed_driving_test.jpg')},
                {'title': 'Pressure Distribution Test Bench', 'desc': 'Contact pressure distribution analysis.' , 'img': require('@/assets/images/lab/eq/force_distribution.jpg')},
                {'title': 'Durability Test Machine', 'desc': 'Wiping durability test (up to 500,000 cycles)' , 'img': require('@/assets/images/lab/eq/durability_test.jpg')},
            ]
        }
    },
}
</script>

<style lang="scss">
    .an-wrap {
        flex:0 0 48%;
        margin-left: 1%;
        margin-right: 1%;
        margin-bottom: 15px;
    }
    @media (min-width: 992px) {
        .an-wrap{
            flex: 0 0 18%;
            margin-left: 1%;
            margin-right: 1%;
        }
    }
</style>